module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/PANS-LABYRINTH.77aa4bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/PANS-LABYRINTH.jpg
// module id = 4gQg
// module chunks = 0